import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'
import useScript from 'react-script-hook'
import { HeaderBrandMain, NF_SERVICE_TYPE } from '@defign/ui'
import useBrowser from '@Hooks/myhouse/useBrowser'

import style from './MyhouseIntroduceHeader.module.scss'

import IconShare24x24 from '@Ui/images/myhouse/introduce/IconShare24x24.svg'

const cx = className.bind(style)

const MyhouseIntroduceHeader: React.FC = () => {
  const { isMobile, isPayApp } = useBrowser()
  const [isScrollTop, setIsScrollTop] = useState(window.scrollY <= 5)
  const [socialLoading, socialError] = useScript({
    src: `${process.env.REACT_APP_SOCIAL_PLUGIN_SOURCE}?v=${Math.floor(new Date().getTime() / 1200000)}`,
    onload: () => {
      window.__splugin = SocialPlugIn_Core({
        //nEvent Key
        evKey: 'realestate',
        serviceName: '부동산',
        dimmed: 'fixed',
        onClick: (button: string) => {
          // button = 버튼명(band:밴드보내기)
        },
        onShow: () => {
          // 공유하기 레이어 노출 후 호출되는 콜백함수
        },
        onHide: () => {
          // 공유하기 레이어 닫기 후 호출되는 콜백함수
        },
      })
    },
  })

  const scrollListener = () => {
    setIsScrollTop(window.scrollY <= 5)
  }

  const handleShareClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (e.target !== e.currentTarget) {
      e.currentTarget.click()
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollListener)
    return () => {
      window.removeEventListener('scroll', scrollListener)
    }
  }, [])

  useEffect(() => {
    if (!socialLoading) {
      window.__splugin.init()
    }
  }, [socialLoading])

  return (
    <header className={cx('header', !isScrollTop && 'type_fixed')}>
      <HeaderBrandMain
        isMobile={isMobile}
        isPayApp={isPayApp}
        serviceType={NF_SERVICE_TYPE.REAL_ESTATE}
        brandLogo={[
          {
            href: process.env.REACT_APP_SPACE_WEB_URL,
          },
          {
            href: process.env.REACT_APP_SPACE_WEB_URL,
          },
        ]}
        rightComponent={
          <button type="button" className={cx('button_share', 'naver-splugin')} onClick={handleShareClick}>
            <IconShare24x24 />
            <span className="blind">공유하기</span>
          </button>
        }
      />
    </header>
  )
}

export default MyhouseIntroduceHeader
